export default "__VITE_ASSET__DdG$rSXT__"